import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Observable, map } from 'rxjs';

import { CmsTarget, CmsTeaser } from '@fcom/core-api';

import { toLinkData } from '../../services/template/data-mappers';

@Component({
  selector: 'cms-cta-with-image-and-text',
  template: `
    <fin-cta-with-image-and-text
      [target$]="cmsTarget$"
      [teaserTitle$]="content$ | finMap: 'teaserTitle'"
      [teaserText$]="content$ | finMap: 'teaserText'"
      [iconUrl$]="content$ | finMap: 'iconUrl'"
    />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsCtaWithImageAndTextComponent implements OnInit {
  @Input()
  content$: Observable<CmsTeaser>;

  cmsTarget$: Observable<CmsTarget>;

  ngOnInit(): void {
    this.cmsTarget$ = this.content$.pipe(map((d) => toLinkData(d.target)));
  }
}
